import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

const app = createApp(App)

// Disable Vuestic Devtools overlay
if (import.meta.env.DEV) {
  window.__VA_DEVTOOLS_DISABLE_OVERLAY__ = true
}
app.use(stores)
app.use(router)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
